import { render } from "./FeedbackMessage.vue?vue&type=template&id=2fee91dd&scoped=true"
import script from "./FeedbackMessage.vue?vue&type=script&lang=js"
export * from "./FeedbackMessage.vue?vue&type=script&lang=js"

import "./FeedbackMessage.vue?vue&type=style&index=0&id=2fee91dd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fee91dd"]])

export default __exports__